module.exports = __webpack_public_path__ + "img/healthcare-activity.0c890e41.jpg";